(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nytc-og-bullet-upgrade"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    function wire(sec){
      if(sec.dataset.bound)return; sec.dataset.bound='1';
      var btn=sec.querySelector('[data-nytc-ogb-add]'),label=btn.querySelector('[data-label]'),done=sec.querySelector('[data-nytc-ogb-done]'),status=sec.querySelector('[data-nytc-ogb-status]');
      var id=Number(sec.dataset.variant),busy=false;
      function paintAdded(){sec.classList.add('is-added');label.textContent='✓ Added · Add another';done.hidden=false;}
      fetch(root+'cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(c){if(c.items.some(function(i){return i.variant_id===id}))paintAdded();}).catch(function(){});
      btn.addEventListener('click',function(){
        if(busy)return; busy=true; btn.disabled=true; status.textContent='';
        fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
        .then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||j.message||'Could not add. Please try again.');return j;})})
        .then(function(){
          paintAdded();
          try{document.dispatchEvent(new CustomEvent('cart:build'));document.dispatchEvent(new CustomEvent('cart:updated'));}catch(e){}
          var opener=document.querySelector('.js-drawer-open-cart');
          setTimeout(function(){ if(opener)opener.click(); },50);
        })
        .catch(function(e){status.textContent=e.message||'Could not add. Please try again.';})
        .then(function(){busy=false;btn.disabled=false;});
      });
    }
    function init(){document.querySelectorAll('[data-nytc-ogb]').forEach(wire);}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
    document.addEventListener('shopify:section:load',init);
  })();

  } catch(e) { console.error(e); }
})();
})();
